import Background from "../../assets/images/counter/counter-bg.jpg";

function AboutSection({ className }) {
  return (
    <section
      className={`about-section pt-120 rpt-100 ${className || ""
        }`}
      id="about-section "
    >
      <div className="container">
        {/* Blue Pane Header - Full Width */}
        <div
          className="fact-counter-inner glass-card text-white text-center mb-5 wow fadeInUp delay-0-2s"
          style={{ position: 'relative', overflow: 'hidden', padding: '40px 30px', borderRadius: '15px', transform: 'none' }}
        >
          {/* Dotted pattern overlay */}
          <div style={{
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundImage: `url(${Background})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: 0.3,
            mixBlendMode: 'overlay',
            zIndex: 0
          }}></div>

          <div style={{ position: 'relative', zIndex: 1 }}>
            <span className="sub-title" style={{ display: 'block', marginBottom: '15px', color: 'rgba(255,255,255,0.8)' }}>
              Support For Business
            </span>
            <h2 style={{ fontSize: '36px', lineHeight: '1.3', margin: 0, color: 'white' }}>
              Preparing for your success trusted source in IT services.
            </h2>
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="about-image-shape rmb-70 wow fadeInLeft delay-0-2s">
              <img
                src={require(`../../assets/images/about/about.png`).default}
                alt="About"
              />
            </div>
          </div>
          <div className="col-lg-6">
            {/* Main Text Content Card */}
            <div className="about-content text-white wow fadeInRight delay-0-4s glass-card" style={{ padding: '40px 50px' }}>
              <p>
                Your success is our priority. As a trusted source in IT
                services, we're dedicated to equipping you with innovative,
                reliable, and efficient solutions. We believe in not only
                meeting your digital needs but also in fostering a partnership
                that helps you thrive in today's technology-driven world.
                Prepare for your success with us, where your IT needs are met
                with precision and expertise.
              </p>
              <ul className="list-style-one mt-15">
                <li>Custom Software Solutions</li>
                <li>Digital Presence Creation</li>
                <li>Cloud-Based Infrastructure</li>
                <li>Information Security Management</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
